import styled from "styled-components";

export const StyledSection = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding-top: 100px;
  padding-top: 0;
  padding-right: 48px;
  padding-left: 48px;

  @media ${({ theme }) => theme.media.mobile} {
    padding-bottom: 60px;
    max-width: 100%;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    padding-top: 60px;
  }
`;

export const DecorativeDot = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 9px;
  position: absolute;
  z-index: 0;
  height: 9px;
  right: 467px; // right-[467px]
  top: 250px; // top-[250px]
`;

export const CarouselContainer = styled.div`
  z-index: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 60px; // mt-[60px]

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    margin-top: 40px; // max-md:mt-10
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  overflow: hidden; /* Hide non-visible cards */
  width: 100%; /* Ensure it takes full width */

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;
